var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('toolbar'),_c('v-content',[_c('scale-transition',{attrs:{"group":"","duration":500,"delay":200}},[_c('router-view',{key:_vm.$route.name})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }